import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import notices, { noticesSaga } from './notices';
import noticeFiles, { noticeFilesSaga } from './noticeFiles';

const dashboardModule = combineReducers({
  notices,
  noticeFiles
});

export function* dashboardModuleSaga() {
  yield all([noticesSaga(), noticeFilesSaga()]);
}

export default dashboardModule;
